import charts from '../charts.js';
import futuresChart from './futures.js';

const estimates = [
	'quarter_revenue',
	'quarter_earnings',
	'year_revenue',
	'year_earnings',
];

// FIXME: some estimates not showing properly

export default function({ id, data, config, dates, defaults }) {
	const settings = {
		dataFormatter(data) {
			return data.map(row => {
				for (const estimate of estimates) {
					row[ `settings_${estimate}` ] = {
						fill:	row[ estimate ] >= 0 ? charts.colours.green : charts.colours.red,
						stroke:	row[ estimate ] >= 0 ? charts.colours.green : charts.colours.red,
					};
				}

				return row;
			});
		},
		scrollbar: false,
		legend: false,
		yAxis: {
			numberFormat: "'$'#",
		},
		panel: {
			panX: false,
		},
	};

	const chart = futuresChart({ id, data, config, dates, settings });

	const defaultEstimate = `${defaults.defaultTimespan}_${defaults.defaultType}`;

	const yAxis = chart.addYAxisWithPrefixes(chart.panel, {
		renderer: {
			opposite: true,
		},

		numberFormat: "'$'#.00a",
		syncWithAxis: chart.yAxis,
	},
	{
		bigNumberPrefixes: charts.bigNumberPrefixes,
		smallNumberPrefixes: [],
	});

	for (const estimate of estimates) {
		const series = chart.addSeries(
			chart.columnSeries(
				{
					name: estimate,
					valueYField: estimate,
					fill: charts.colours.green,
					stroke: charts.colours.green,
					templateField: `settings_${estimate}`,
					layer: 0,
					width: 16,
					tooltip: {
						labelFunction(row) {
							return `Analysts estimate ${estimate.includes('earnings') ? 'earnings per share' : 'revenue'} of [bold]$${row[ estimate ]}[/].`
						},
					},
				},
				yAxis
			)
		);

		if (estimate !== defaultEstimate) {
			chart.toggleSeries(estimate, false);
		}
	}

	chart.chartReady();

	return chart;
};
